export function getBans ({ state, commit }, { search, page = 1 }) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/bans', { params: { search, page } })
      .then((response) => {
        if (response.data.bans) {
          commit('setBans', response.data.bans)
        }

        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function createBan ({ state, commit }, ip) {
  return new Promise((resolve, reject) => {
    axiosInstance.post('/v1/bans', { ip })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function deleteBan ({ state, commit }, ip) {
  return new Promise((resolve, reject) => {
    if (ip) {
      axiosInstance.delete('/v1/bans/' + ip)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No ip'))
    }
  })
}
